import React from "react"
import moment from "moment"
import { LedgerType } from "../../../src/pages/pto/types"
import Select from "react-select"

/**bk4/26/2022...Remove unused vars and props, unify string initiators from ' to "", add redundant comments...*/

export interface IProps {
    ptoData: {
        ledger: Array<LedgerType>
        ArchivedYears: string[]
    }
    startDate: Number|null
    setFromToDate: Function 
    loading: boolean
}

const LedgerYearFilterSelect: React.FC<IProps> = (props) => {
    const { ptoData, startDate, setFromToDate, loading } = props

    const filteredYears = () => {
        let years = ptoData.ArchivedYears
        let arr = []
        arr.push({ label: new Date().getFullYear().toString(), value: moment(`${new Date().getFullYear} GMT+01:00`)})
        for (let i = 0; i < years.length; i++) {
            //cgm 042922 =>> this was a literal nightmare. Needs the GMT+1.  Will not see dates on 01/01/whatever unless it does.
            let dateValue = moment(`${years[i]} GMT+01:00`)
            // let momentDateValue = moment(years[i]);
            arr.push({ label: years[i], value: dateValue});
        }
        return arr
    }

    const filteredYearsArr = filteredYears()

    return (
        <div className="LedgerYearFilterSelect">{/*name this something else than <> to find it easily in the future*/}
            <Select
                //@ts-ignore
                onChange={(e: { label: string, value: moment.Moment }) => {
                    if(e && e.label===new Date().getFullYear().toString()){
                        setFromToDate(null)
                    }
                    else if(e){
                        setFromToDate(e.label)
                    }                    
                    else{
                        setFromToDate(null)
                    }
                }}
                options={filteredYearsArr}
                value={filteredYearsArr.find((year: any) => year.value === startDate || startDate === null? new Date().getFullYear().toString(): false)}
                isLoading={loading}
                isDisabled={loading}
                placeholder={"Current Year"}
                // defaultValue={thisYear}
            />
        </div>
    )
}

export default LedgerYearFilterSelect